<div class="animated fadeInRight">
    <!-- MENU DE TITULOS -->
    <app-lfsa-card-v2
      [titulo]      = "DAT_TITULOS.titulo"
      [modulo]      = "GLOBAL_TITULOS.modulo"
      [tituloCard]  = "titleModal"
      [innTemplate] = "enviarTemplateEdit"
      [innTemplateButton]="innTemplateButton">
    </app-lfsa-card-v2>
    <!-- MENU DE TITULOS -->

    <!-- OPCIONES BOTONES IZQUIERDO -->
    <ng-template #innTemplateButton>
      <div class="col-md-6 mb-2">
        <div class="pagetitle">
          <div class="btn-group-justified btn-group" style="float: right;" *ngIf="!isCreate && !isBalanza">
            <button (click)="nuevo()" class="btn btn-primary"> <i aria-hidden="true" class="fa fa-plus"></i> Agregar </button>
          </div>
        </div>
      </div>
    </ng-template>
    <!-- OPCIONES BOTONES IZQUIERDO -->


    <ng-template #enviarTemplateEdit>
        <!-- GRILLA -->
        <div class="row" *ngIf="!isCreate || isBalanza">
            <div class="form-group col-md-12">
                <input class="form-control" placeholder="Buscar.. " [(ngModel)]="textoBuscar " id="quickFilter " (keyup)="onQuickFilterChanged() " #quickFilter />
            </div>

            <app-lfsa-loading-v2 *ngIf="loading"></app-lfsa-loading-v2>
            <div class="col mt-4">
                <ag-grid-angular #agGrid (gridReady)="onGridReady($event)"
                                    [id]    ="DAT_AG_GRID.id"
                                    [class] ="DAT_AG_GRID.class"
                                    [ngStyle]="DAT_AG_GRID.style"
                                    [rowModelType]="rowModelType"
                                    [rowData]="isBalanza ? rowData : null"
                                    [datasource]="!isBalanza ? datasource : null"
                                    [rowSelection] = 'rowSelection'
                                    [columnDefs]="columnDefs"
                                    [pagination]="DAT_AG_GRID.pagination"
                                    [paginationPageSize]="!isBalanza ? pageSize : DAT_AG_GRID.pagina"
                                    [cacheBlockSize]="!isBalanza ? pageSize : null"
                                    [allowContextMenuWithControlKey]="true"
                                    [rowHeight]="DAT_AG_GRID.rowHeight"
                                    [frameworkComponents]="frameworkComponents" >
                </ag-grid-angular>
            </div>

            <div class="col mt-4" *ngIf="bitacora.length > 0">
                <button type="button" class="btn btn-info btn-block" (click)="resetBitacora()">X</button>
                <app-bitacora-historico
                    [bitacora]="bitacora">
                </app-bitacora-historico>
            </div>
        </div>

        <!-- FORM PLANIFICACION -->
        <div class="alert alert-warning" role="alert" *ngIf="this.conexionSensores">
          Conexión de Equipos: Estado de conexión - {{ respuestaOnlyControl?.detalle }} -
          <button type="button" class="btn-close" data-bs-dismiss="alert" aria-label="Close"></button>
        </div>
        <!--
        <div class="alert alert-danger" role="alert" *ngIf="!this.respuestaOnlyControl ">
          Problema de conexión, por favor verifique más tarde
          <button type="button" class="btn-close" data-bs-dismiss="alert" aria-label="Close"></button>
        </div>
        -->

        <div class="row" >
            <div class="container-fluid mt-30" >
                <form [formGroup]="formulario" (ngSubmit)="onFormSubmit($event)" (keydown.enter)="onKeydownEnter($event)" mat-dialog-content *ngIf="!isBalanza && (isCreate || selected)">
                    <div class="row">
                        <hr><h6> Hora Inicio Proceso: {{fechaHoraInicio}} </h6><hr>
                        <div class="col" *ngIf="isCreate">
                            <app-lfsa-input formControlName="idViaje" [label]="'ID Viaje '" [id]="'idViaje'"
                                [isReadOnly]="true" [control]="formulario.get('idViaje')" [type]="'number'" class="form-control-sm" >
                            </app-lfsa-input>
                        </div>

                        <div class="col">
                            <app-lfsa-combo-box [label]="'* Seleccione Tipo'" formControlName="tipo" [control]="formulario.get('tipo')"
                                                [comboBox]="listTipos" [opcion]="'nombre'" [idOpcion]="'idTipo'" [habilitar]="selected != null" class="form-control-sm">
                            </app-lfsa-combo-box>
                        </div>
                        <!-- NUEVOS CAMPOS 1-->
                        <div class="col">
                            <app-lfsa-combo-box [label]="'* Tipo de Carga'" formControlName="tipoCarga" [control]="formulario.get('tipoCarga')" 
                                                [habilitar]="tipoSelected?.idTipo == undefined || tipoSelected?.idTipo == null"
                                                [comboBox]="listCatalogos?.tipoCarga" [opcion]="'valor'" [idOpcion]="'clave'" class="form-control-sm">
                            </app-lfsa-combo-box>
                        </div>
                        <!-- Elimina *ngIf="!this.isFocus"-->
                        <div class="col" >
                            <app-lfsa-combo-box [label]="'* Prioridad según Tipo'" formControlName="prioridad" [control]="formulario.get('prioridad')"
                                                [habilitar]="true" [comboBox]="listCatalogos?.prioridades" [opcion]="'valor'" [idOpcion]="'clave'" class="form-control-sm">
                            </app-lfsa-combo-box>
                        </div>
                    </div>

                    <!--SECCIÓN EN CASO DE QUE GENERA TICKET DE BALANZA [habilitar]="selected != null" -->
                    <div class="row" *ngIf="tipoSelected?.generaTicketBalanza">
                        <div class="col">
                            <app-lfsa-combo-box [label]="'* Tipo Orden Balanza'" formControlName="tipoOrdenBalanza" [control]="formulario.get('tipoOrdenBalanza')"
                                                id="tipoOrdenBalanza" [comboBox]="cmbTipoOrden" [opcion]="'desca'" [idOpcion]="'id'" class="form-control-sm">
                            </app-lfsa-combo-box>
                        </div>
                    </div>

                    <!-- AMPLIACION DE FUNCIONALIDAD COMUNES 2 VENTAS -->
                    <!-- *ngIf="!this.isFocus" -->
                    <div class="row" >
                        <div class="col" *ngIf=" this.tipoCarga == 2 && tipoSelected?.tipoEscenario == 'VENTA'">
                            <label class="mb-2" for="aplicaSalidaDevolucion">Aplicar Salida o Devolución</label>
                            <div class="form-check">
                                <input class="form-check-input" id="aplicaSalidaDevolucion" formControlName="aplicaSalidaDevolucion" type="checkbox">
                                <label class="form-check-label" for="aplicaSalidaDevolucion">{{this.formulario.get('aplicaSalidaDevolucion').value ? 'Si' : 'No'}}</label>
                            </div>
                        </div>
                        <!-- agrega campos para ventas tipo graneles -->
                        <div class="col" *ngIf=" this.tipoCarga == 2 && tipoSelected?.tipoEscenario == 'VENTA'">
                            <app-lfsa-input formControlName="extractoraPesoNeto" [label]="'Peso Neto'" [id]="'extractoraPesoNeto'" maxlength="5"
                            [control]="formulario.get('extractoraPesoNeto')" class="form-control-sm" [type]="'number'" >
                            </app-lfsa-input>
                        </div>

                      <div class="col" *ngIf="(tipoSelected?.requiereOrden || tipoSelected?.tipoEscenario != 'VENTA') && tipoSelected?.tipoEscenario != 'TRASLADO'">
                            <app-lfsa-input formControlName="orden" [label]="'Número de orden'" [id]="'orden'" [control]="formulario.get('orden')"
                            class="form-control-sm" [type]="'text'" class="form-control-sm" maxlength="20">
                            </app-lfsa-input>
                        </div>
                        <div class="col" *ngIf="tipoSelected?.requiereTanquero">
                            <app-lfsa-input formControlName="tanquero" [label]="'N# Tanquero'" [id]="'tanquero'" [control]="formulario.get('tanquero')"
                            class="form-control-sm" [type]="'number'" class="form-control-sm" maxlength="4">
                            </app-lfsa-input>
                        </div>
                        <div class="col" *ngIf="tipoSelected?.requiereBuque">
                            <app-lfsa-input formControlName="buque" [label]="'Buque'" [id]="'buque'" [control]="formulario.get('buque')"
                            [placeholder]="'AxxxN'" class="form-control-sm" [type]="'text'" class="form-control-sm" maxlength="10">
                            </app-lfsa-input>
                        </div>
                    </div>


                    <!-- PROVEEDOR TRANSPORTE PLACA Y CHOFER-->
                    <div class="row m-1 border border-success rounded" >
                        <strong class="pt-2">Datos del Transporte</strong><br>
                        <div class="row">
                            <div class="col-md-4">
                                <div class="d-flex align-items-end">
                                    <div class="flex-grow-1">
                                        <app-lfsa-input
                                            [mostrarMjsError]="false"
                                            formControlName="proveedorId"
                                            [label]="'* Código proveedor Transporte'"
                                            [id]="'proveedorId'"
                                            [control]="formulario.get('proveedorId')"
                                            [placeholder]="'Código proveedor'"
                                            (change)="getProveedor(); getPlacas(formulario.get('proveedorId').value); this.getTiposRecursos();  this.getFurgones(); this.getChoferDisponibles();"
                                            class="form-control-sm"
                                            [type]="'text'">
                                        </app-lfsa-input>
                                    </div>

                                    <div class="ml-2" style="margin-bottom: 2.5rem;">
                                        <app-busqueda-proveedor
                                            (onSelect)="proveedorSeleccionado($event)">
                                        </app-busqueda-proveedor>
                                    </div>
                                </div>
                            </div>
                            <div class="col-md-4">
                                <app-lfsa-input formControlName="proveedorNombre" [label]="'* Detalle proveedor'" [id]="'proveedorNombre'" [control]="formulario.get('proveedorNombre')"
                                [placeholder]="'Nombre proveedor'" [type]="'text'" class="form-control-sm" [isReadOnly]="true">
                                </app-lfsa-input>
                            </div>
                            <div class="col">
                                <!-- <app-lfsa-input formControlName="placa" [label]="'* Placa'" [id]="'placa'" [control]="formulario.get('placa')"
                                (change)="getPlaca();" [type]="'text'" class="form-control-sm" >
                                </app-lfsa-input> -->
                                <app-lfsa-loading-v2 *ngIf="placasLoading"></app-lfsa-loading-v2>
                                <label for="usuario">Seleccionar Placa</label>
                                <ng-select [items]="placas"
                                            formControlName="placa"
                                            placeholder="Seleccione una Placa"
                                            [clearable]="false"
                                            bindLabel="placa"
                                            bindValue="placa"
                                            (change)="OnChangePlaca($event);">
                               </ng-select>
                            </div>
                        </div>

                        <div class="row">
                            <div class="col">
                                <app-lfsa-combo-box [label]="'* Tipo de Recurso'" formControlName="tipoRecurso" [control]="formulario.get('tipoRecurso')"
                                                    [comboBox]="listTipoTransporte" [opcion]="'clave'" [idOpcion]="'valor'" class="form-control-sm" (change)="getFurgonesFilter()">
                                </app-lfsa-combo-box>
                            </div>
                            <div class="col">
                               <label class="claseLabel" for="furgon">* Seleccione Furgon</label>
                                <ng-select [items]="listFurgones"
                                           [labelForId]="'furgon'"
                                           formControlName="furgon"
                                           placeholder="Seleccione un Furgon"
                                           [clearable]="false"
                                           bindLabel="marca"
                                           bindValue="placa"
                                           [addTag]="permiteDigitarFurgon ? addTagFurgon : false"
                                           [ngClass]="{'is-invalid': formulario.get('furgon').invalid && formulario.get('furgon').dirty, 'is-valid': formulario.get('furgon').valid && formulario.get('furgon').dirty}">
                                </ng-select>
                            </div>
                        </div>
                        <div class="row">
                            <div class="col">
                                <!--<app-lfsa-input formControlName="choferCedula" [label]="'* Cédula chofer'" [id]="'choferCedula'" [control]="formulario.get('choferCedula')"
                                [placeholder]="'Ingrese cédula del chofer (sin - u otros simbolos)'" (change)="getChofer();" [type]="'text'" class="form-control-sm" >
                                </app-lfsa-input>
                                -->
                                <app-lfsa-input formControlName="choferNombre" [label]="'* Filtrar por nombre chofer'" [id]="'choferNombre'" [control]="formulario.get('choferNombre')"
                                [placeholder]="'Nombre chofer'" [type]="'text'" class="form-control-sm" (change)="getChofer();">
                                </app-lfsa-input>

                            </div>
                            <div class="col">
                                <app-lfsa-combo-box [label]="'* Lista de Choferes'" formControlName="choferCedula" [control]="formulario.get('choferCedula')"
                                                    [comboBox]="listChoferes" [opcion]="'nombres'" [idOpcion]="'cedula'" class="form-control-sm" >
                                </app-lfsa-combo-box>
                            </div>

                            <div class="col">
                                <app-lfsa-input formControlName="choferTelefono" [label]="'* Télefono chofer'" [id]="'choferTelefono'" [control]="formulario.get('choferTelefono')"
                                [placeholder]="'Télefono chofer'" [type]="'text'" class="form-control-sm" >
                                </app-lfsa-input>
                            </div>
                        </div>
                    </div>

                    <!-- AMPLIACION DE FUNCIONALIDADES VENTA, COMPRAS Y CAMPOS COMUNES -->
                    <div class="row m-1 mt-4 border border-success rounded" *ngIf="tipoSelected?.tipoEscenario == 'VENTA'">
                        <strong class="pt-2">Datos del Cliente</strong><br>
                        <div class="col">
                            <div class="d-flex align-items-end">
                                <div class="flex-grow-1">
                                    <app-lfsa-input formControlName="cliente" [label]="'* Código Cliente'" [id]="'cliente'" [control]="formulario.get('cliente')"
                                    [placeholder]="'Código Cliente'" (change)="getCliente();" class="form-control-sm" [type]="'text'" >
                                    </app-lfsa-input>
                                </div>
                                <div class="ml-1" style="margin-bottom: 2.5rem;">
                                     <app-busqueda-cliente (onSelect)="clienteSeleccionado($event)"></app-busqueda-cliente>
                                 </div>
                            </div>
                        </div>
                        <div class="col">
                            <app-lfsa-input formControlName="clienteNombre" [label]="'* Detalle cliente'" [id]="'clienteNombre'" [control]="formulario.get('clienteNombre')"
                            [placeholder]="'Nombre cliente'" [type]="'text'" class="form-control-sm" [isReadOnly]="true">
                            </app-lfsa-input>
                        </div>
                        <!-- Elimina *ngIf="!this.isFocus"-->
                        <div class="col" *ngIf="!this.isVntContenerizada">
                            <app-lfsa-input formControlName="cantidadDespacho" [label]="'Cantidad Despacho (opcional)'" [id]="'cantidadDespacho'" [control]="formulario.get('cantidadDespacho')"
                            class="form-control-sm" [type]="'text'" class="form-control-sm">
                            </app-lfsa-input>
                        </div>
                    </div>

                    <!-- AMPLIACION DE FUNCIONALIDAD COMPRA 3 -->
                    <!-- && !this.isFocus -->
                    <div class="row align-items-end" *ngIf="comprasControl" formGroupName="compras" >
                        <div class="col-md-4" *ngIf="tipoSelected?.tipoEscenario == 'COMPRA' || tipoSelected?.tipoEscenario == 'INFORMATIVO'">
                            <app-lfsa-input formControlName="proveedorCompra" [label]="'* Proveedor Compra'" [id]="'proveedorCompra'"
                            [control]="formulario.get('compras.proveedorCompra')" class="form-control-sm" [type]="'text'" class="form-control-sm" (change)="getProveedor(false)" >
                            </app-lfsa-input>
                        </div>
                        <div class="col-md-4" *ngIf="tipoSelected?.tipoEscenario == 'COMPRA' || tipoSelected?.tipoEscenario == 'INFORMATIVO'">
                            <app-lfsa-input formControlName="proveedorCompraName" [label]="'Detalle proveedor'" [id]="'proveedorCompraName'"
                            [control]="formulario.get('compras.proveedorCompraName')" [placeholder]="'Nombre proveedor'" [type]="'text'" class="form-control-sm" [isReadOnly]="true">
                            </app-lfsa-input>
                        </div>
                        <div class="col-md-4" *ngIf="tipoSelected?.requiereOrigen">
                            <app-lfsa-combo-box [label]="'Extractora Origen'" formControlName="extractoraId" [control]="formulario.get('compras.extractoraId')"
                                                [comboBox]="listOrigen" [opcion]="'descripcion'" [idOpcion]="'id'" class="form-control">
                            </app-lfsa-combo-box>
                        </div>
                    </div>

                    <!-- CAMPOS DE PESO FIJOS -->
                    <!-- && !this.isFocus -->
                    <div class="row" *ngIf="comprasControl" >
                        <div class="col-md-4">
                            <app-lfsa-input formControlName="extractoraPesoNeto" [label]="'Peso Neto'" [id]="'extractoraPesoNeto'" maxlength="5"
                            [control]="formulario.get('extractoraPesoNeto')" class="form-control-sm" [type]="'number'" >
                            </app-lfsa-input>
                        </div>
                        <div class="col-md-4">
                            <app-lfsa-input formControlName="extractoraPesoBruto" [label]="'Peso Bruto'" [id]="'extractoraPesoBruto'" maxlength="5"
                            [control]="formulario.get('extractoraPesoBruto')" class="form-control-sm" [type]="'number'" >
                            </app-lfsa-input>
                        </div>
                        <div class="col-md-4">
                            <app-lfsa-input formControlName="extractoraPesoTara" [label]="'Peso Tara'" [id]="'extractoraPesoTara'" maxlength="5"
                            [control]="formulario.get('extractoraPesoTara')" class="form-control-sm" [type]="'number'" >
                            </app-lfsa-input>
                        </div>
                    </div>
                    <!-- AMPLIACION DE FUNCIONALIDAD COMPRA 3 -->
                    <!-- && !this.isFocus -->
                    <div class="row" *ngIf="comprasControl && tipoSelected?.requiereOrigen" formGroupName="compras">
                        <div class="col">
                            <app-lfsa-input formControlName="extractoraAcidez" [label]="'Acidez Extractora'" [id]="'extractoraAcidez'"
                            [control]="formulario.get('compras.extractoraAcidez')" class="form-control-sm" [type]="'number'" class="form-control-sm" maxlength="7">
                            </app-lfsa-input>
                        </div>
                        <div class="col">
                            <app-lfsa-input formControlName="extractoraHumedad" [label]="'Humedad Extractora'" [id]="'extractoraHumedad'"
                            [control]="formulario.get('compras.extractoraHumedad')" class="form-control-sm" [type]="'number'" class="form-control-sm" maxlength="7">
                            </app-lfsa-input>
                        </div>
                        <div class="col">
                            <app-lfsa-input formControlName="extractoraImpureza" [label]="'Impureza Extractora'" [id]="'extractoraImpureza'"
                            [control]="formulario.get('compras.extractoraImpureza')" class="form-control-sm" [type]="'number'" class="form-control-sm" maxlength="7">
                            </app-lfsa-input>
                        </div>
                    </div>


                    <div class="row m-1 pt-2 mt-4 border border-success rounded">
                        <strong class="pt-2">Origen y Destino</strong> <label> destino(no aplica para ventas). </label>
                        <hr class="mt-2">
                        <div class="col-sm form-group" *ngIf="tipoSelected?.tipoEscenario != 'VENTA' || tipoSelected?.nombre == 'MIX PTA'">
                            <app-lfsa-combo-box [label]="'* Seleccione Centro Destino'" formControlName="centroDestino" [control]="formulario.get('centroDestino')"
                                                [comboBox]="LISTA_CENTO_DESTINO" [opcion]="'descripcion'" [idOpcion]="'id'" (change)="getAlmacen(false);" class="form-control-sm">
                            </app-lfsa-combo-box>
                        </div>
                        <!-- AMPLIACION DE CAMPOS 5 -->
                        <div class="col-sm form-group" *ngIf="tipoSelected?.tipoEscenario != 'VENTA' || tipoSelected?.nombre == 'MIX PTA' ">
                            <app-lfsa-combo-box [label]="'Bodega/Recepción Destino'" formControlName="almacenDestino" [control]="formulario.get('almacenDestino')"
                                                [comboBox]="listAgenciasDestino" [opcion]="'dscaAlmacen'" [idOpcion]="'idAlmacen'" class="form-control-sm"
                                                [isReadOnly]="true">
                            </app-lfsa-combo-box>
                        </div>
                        <div class="col-sm form-group">
                            <app-lfsa-combo-box [label]="'* Seleccione Centro Carga Origen'" formControlName="centroOrigen" [control]="formulario.get('centroOrigen')"
                                                [comboBox]="listCentros" [opcion]="'nombreCentro'" [idOpcion]="'idCentro'"  class="form-control-sm">   <!-- (change)="getAlmacenByCentroUser($event)" -->
                            </app-lfsa-combo-box>
                        </div>
                        <div class="col-sm form-group">
                            <app-lfsa-combo-box [label]="'* Seleccione Bodega/Carga Origen'" formControlName="bodegaCarga" [control]="formulario.get('bodegaCarga')"
                                                [comboBox]="listAgencias" [opcion]="'dscaAlmacen'" [idOpcion]="'idAlmacen'" class="form-control-sm" >
                            </app-lfsa-combo-box>
                        </div>
                    </div>
                    <hr>

                    <div class="row py-2">
                    <!-- AMPLIAR PLANIFICACION 6 -->
                    <!-- *ngIf="!this.isFocus" -->
                    <div class="col" *ngIf="tipoSelected?.requiereArea">
                        <app-lfsa-combo-box [label]="'* Áreas por Centro destino'" formControlName="areaId" [control]="formulario.get('areaId')"
                                            [comboBox]="listAreas" [opcion]="'descArea'" [idOpcion]="'idArea'" class="form-control-sm">
                        </app-lfsa-combo-box>
                    </div>
                    <!-- *ngIf="!this.isFocus" -->
                    <!--  T.42031 RF: 1.6 1.7 -->
                    <div class="col" *ngIf="!this.isVntContenerizada && tipoSelected?.tipoEscenario != 'TRASLADO'">
                        <app-lfsa-input formControlName="materialId" [label]="'Código material'" [id]="'materialId'" [control]="formulario.get('materialId')"
                        [placeholder]="'Código material'" class="form-control-sm" [type]="'text'" class="form-control-sm" >
                        </app-lfsa-input> 
                    </div>
                    <!-- *ngIf="!this.isFocus" -->
                     <!--  T.42031 RF: 1.6 1.7 -->
                    <div class="col" *ngIf="!this.isVntContenerizada && tipoSelected?.tipoEscenario != 'TRASLADO'">
                        <app-lfsa-input formControlName="materialRef" [label]="'Referencia material'" [id]="'materialRef'" [control]="formulario.get('materialRef')"
                        [placeholder]="'referencia'" class="form-control-sm" [type]="'text'" class="form-control-sm" >
                        </app-lfsa-input>
                    </div>

                    <div class="col">
                        <label for="fechaLlegada" style="font-size: .875rem;">Fecha y hora planificada de llegada</label>
                        <input autocomplete="off" class="form-control" formControlName="fechaLlegada" (change)="onFechaLlegadaChange()"
                        id="fechaLlegada" name="fechaLlegada" type="datetime-local" min="2025-01-01T00:00" max="2030-12-31T00:00" />
                        <small *ngIf="this.formulario.get('fechaLlegada')?.hasError('required') && this.formulario.get('fechaLlegada').touched"
                        class="text-danger">*Campo obligatorio</small>
                        <small *ngIf="this.formulario.get('fechaLlegada')?.hasError('pastDate') && this.formulario.get('fechaLlegada').touched"
                        class="text-danger">*La fecha no puede ser menor a la actual</small>
                    </div>

                    <div class="col">
                        <app-lfsa-combo-box [label]="'* Estado '" formControlName="estado" [control]="formulario.get('estado')"
                                            [comboBox]="cmbxEstados" [opcion]="'valor'" [idOpcion]="'clave'" [habilitar]="true" class="form-control-sm">
                        </app-lfsa-combo-box>
                    </div>
                </div>

                <app-lfsa-botones-formulario
                    (devolverAccion) ="acciones($event)"
                    [formularioValido] ="formulario.invalid"
                    [mostrarBotonVerde] = "selected == null || permiteEditar"
                    [loading]="loading" [textBoton]="'Guardar'" class="row p-3">
                </app-lfsa-botones-formulario>
                </form>
            </div>
        </div>

    </ng-template>
    <!-- GRILLA -->
</div>

    <!-- MODAL FORM PLANIFICACION -->
    <app-lfsa-modal [innTemplate] = "abrirModal" [classModal] = "'modal-dialog modal-lg'" [idButton]="'abrirModal'"
        [idOpen]="'Modal'" [idClose] = "'cerrarModal'" [titulo] = "titleModal">
    </app-lfsa-modal>

    <ng-template #abrirModal>
        <div class="container-fluid">
            <form [formGroup]="formulario" (ngSubmit)="onFormSubmit($event)" (keydown.enter)="onKeydownEnter($event)" mat-dialog-content>
                <div class="row">
                    <h6> Hora Inicio Proceso: {{fechaHoraInicio}} </h6><hr>
                <div class="col" *ngIf="!isCreate">
                        <app-lfsa-input formControlName="idViaje" [label]="'ID Viaje '" [id]="'idViaje'"
                            [isReadOnly]="true" [control]="formulario.get('idViaje')" [type]="'number'" class="form-control-sm" >
                        </app-lfsa-input>
                    </div>
                    <div class="col">
                        <app-lfsa-combo-box [label]="'* Seleccione Tipo'" formControlName="tipo" [control]="formulario.get('tipo')"
                                        [comboBox]="listTipos" [opcion]="'nombre'" [idOpcion]="'idTipo'" [habilitar]="!isCreate" class="form-control-sm">
                        </app-lfsa-combo-box>
                    </div>
                    <!-- NUEVOS CAMPOS 1-->
                    <div class="col">
                        <app-lfsa-combo-box [label]="'* Tipo de Carga'" formControlName="tipoCarga" [control]="formulario.get('tipoCarga')"
                                            [comboBox]="listCatalogos?.tipoCarga" [opcion]="'valor'" [idOpcion]="'clave'" class="form-control-sm">
                        </app-lfsa-combo-box>
                    </div>
                    <!-- Elimina *ngIf="!this.isFocus"-->
                    <div class="col" >
                        <app-lfsa-combo-box [label]="'* Prioridad según Tipo'" formControlName="prioridad" [control]="formulario.get('prioridad')"
                                            [habilitar]="true" [comboBox]="listCatalogos?.prioridades" [opcion]="'valor'" [idOpcion]="'clave'" class="form-control-sm">
                        </app-lfsa-combo-box>
                    </div>
                </div>
                <!--SECCIÓN EN CASO DE QUE GENERA TICKET DE BALANZA -->
                <div class="row" *ngIf="tipoSelected?.generaTicketBalanza">
                    <div class="col">
                        <app-lfsa-combo-box [label]="'* Tipo Orden Balanza'" formControlName="tipoOrdenBalanza" [control]="formulario.get('tipoOrdenBalanza')"
                                        id="tipoOrdenBalanza" [comboBox]="cmbTipoOrden" [opcion]="'desca'" [idOpcion]="'id'" [habilitar]="!isCreate" class="form-control-sm">
                        </app-lfsa-combo-box>
                    </div>
                </div>

                <!-- AMPLIACION DE FUNCIONALIDADES VENTA, COMPRAS Y CAMPOS COMUNES -->
                <div class="row" *ngIf="tipoSelected?.tipoEscenario == 'VENTA'">
                    <div class="col">
                        <app-lfsa-input formControlName="cliente" [label]="'* Código Cliente'" [id]="'cliente'" [control]="formulario.get('cliente')"
                        [placeholder]="'Código Cliente'" (change)="getCliente();" class="form-control-sm" [type]="'text'" class="form-control-sm" >
                        </app-lfsa-input>
                    </div>
                    <div class="col">
                        <app-lfsa-input formControlName="clienteNombre" [label]="'* Detalle cliente'" [id]="'clienteNombre'" [control]="formulario.get('clienteNombre')"
                        [placeholder]="'Nombre cliente'" [type]="'text'" class="form-control-sm" [isReadOnly]="true">
                        </app-lfsa-input>
                    </div>
                    <!-- Elimina *ngIf="!this.isFocus"-->
                     <!--  T.42031 RF: 1.6 1.7 -->
                    <div class="col" *ngIf="!this.isVntContenerizada">
                        <app-lfsa-input formControlName="cantidadDespacho" [label]="'Cantidad Despacho'" [id]="'cantidadDespacho'" [control]="formulario.get('cantidadDespacho')"
                        class="form-control-sm" [type]="'text'" class="form-control-sm">
                        </app-lfsa-input>
                    </div>
                </div>

                <!-- AMPLIACION DE FUNCIONALIDAD COMUNES 2 -->
                <!-- *ngIf="!this.isFocus" -->
                <div class="row" >
                    <div class="col">
                        <label class="mb-2" for="aplicaSalidaDevolucion">Aplicar Salida o Devolución</label>
                        <div class="form-check">
                            <input class="form-check-input" id="aplicaSalidaDevolucion" formControlName="aplicaSalidaDevolucion" type="checkbox">
                            <label class="form-check-label" for="aplicaSalidaDevolucion">{{this.formulario.get('aplicaSalidaDevolucion').value ? 'Si' : 'No'}}</label>
                        </div>
                    </div>
                    <!-- agrega campos para ventas tipo graneles -->
                    <div class="col" *ngIf=" this.tipoCarga == 2 && tipoSelected?.tipoEscenario == 'VENTA'">
                        <app-lfsa-input formControlName="extractoraPesoNeto" [label]="'Peso Neto'" [id]="'extractoraPesoNeto'" maxlength="5"
                        [control]="formulario.get('extractoraPesoNeto')" class="form-control-sm" [type]="'number'" >
                        </app-lfsa-input>
                    </div>

                  <div class="col" *ngIf="(tipoSelected?.requiereOrden || tipoSelected?.tipoEscenario != 'VENTA') && tipoSelected?.tipoEscenario != 'TRASLADO'">
                        <app-lfsa-input formControlName="orden" [label]="'Número de orden'" [id]="'orden'" [control]="formulario.get('orden')"
                        class="form-control-sm" [type]="'text'" class="form-control-sm" maxlength="20">
                        </app-lfsa-input>
                    </div>
                    <div class="col" *ngIf="tipoSelected?.requiereTanquero">
                        <app-lfsa-input formControlName="tanquero" [label]="'N# Tanquero'" [id]="'tanquero'" [control]="formulario.get('tanquero')"
                        class="form-control-sm" [type]="'number'" class="form-control-sm" maxlength="4">
                        </app-lfsa-input>
                    </div>
                    <div class="col" *ngIf="tipoSelected?.requiereBuque">
                        <app-lfsa-input formControlName="buque" [label]="'Buque'" [id]="'buque'" [control]="formulario.get('buque')"
                        [placeholder]="'AxxxN'" class="form-control-sm" [type]="'text'" class="form-control-sm" maxlength="10">
                        </app-lfsa-input>
                    </div>
                </div>

                <!-- AMPLIACION DE FUNCIONALIDAD COMPRA 3 -->
                <!-- && !this.isFocus -->
                <div class="row align-items-end" *ngIf="comprasControl" formGroupName="compras" >
                    <div class="col-md-4" *ngIf="tipoSelected?.tipoEscenario == 'COMPRA' || tipoSelected?.tipoEscenario == 'INFORMATIVO'">
                        <app-lfsa-input formControlName="proveedorCompra" [label]="'* Proveedor Compra'" [id]="'proveedorCompra'"
                        [control]="formulario.get('compras.proveedorCompra')" class="form-control-sm" [type]="'text'" class="form-control-sm" (change)="getProveedor(false)" >
                        </app-lfsa-input>
                    </div>
                    <div class="col-md-4" *ngIf="tipoSelected?.tipoEscenario == 'COMPRA' || tipoSelected?.tipoEscenario == 'INFORMATIVO'">
                        <app-lfsa-input formControlName="proveedorCompraName" [label]="'Detalle proveedor'" [id]="'proveedorCompraName'"
                        [control]="formulario.get('compras.proveedorCompraName')" [placeholder]="'Nombre proveedor'" [type]="'text'" class="form-control-sm" [isReadOnly]="true">
                        </app-lfsa-input>
                    </div>
                    <div class="col-md-4" *ngIf="tipoSelected?.requiereOrigen">
                        <app-lfsa-combo-box [label]="'Extractora Origen'" formControlName="extractoraId" [control]="formulario.get('compras.extractoraId')"
                                            [comboBox]="listOrigen" [opcion]="'descripcion'" [idOpcion]="'id'" class="form-control">
                        </app-lfsa-combo-box>
                    </div>
                </div>

                <!-- CAMPOS DE PESO FIJOS -->
                <!-- && !this.isFocus -->
                <div class="row" *ngIf="comprasControl && tipoSelected?.requiereOrigen" >
                    <div class="col-md-4">
                        <app-lfsa-input formControlName="extractoraPesoNeto" [label]="'Peso Neto'" [id]="'extractoraPesoNeto'" maxlength="5"
                        [control]="formulario.get('extractoraPesoNeto')" class="form-control-sm" [type]="'number'" >
                        </app-lfsa-input>
                    </div>
                    <div class="col-md-4">
                        <app-lfsa-input formControlName="extractoraPesoBruto" [label]="'Peso Bruto'" [id]="'extractoraPesoBruto'" maxlength="5"
                        [control]="formulario.get('extractoraPesoBruto')" class="form-control-sm" [type]="'number'" >
                        </app-lfsa-input>
                    </div>
                    <div class="col-md-4">
                        <app-lfsa-input formControlName="extractoraPesoTara" [label]="'Peso Tara'" [id]="'extractoraPesoTara'" maxlength="5"
                        [control]="formulario.get('extractoraPesoTara')" class="form-control-sm" [type]="'number'" >
                        </app-lfsa-input>
                    </div>
                </div>
                <!-- AMPLIACION DE FUNCIONALIDAD COMPRA 3 -->
                <!-- && !this.isFocus -->
                <div class="row" *ngIf="comprasControl && tipoSelected?.requiereOrigen" formGroupName="compras">
                    <div class="col">
                        <app-lfsa-input formControlName="extractoraAcidez" [label]="'Acidez Extractora'" [id]="'extractoraAcidez'"
                        [control]="formulario.get('compras.extractoraAcidez')" class="form-control-sm" [type]="'number'" class="form-control-sm" maxlength="7">
                        </app-lfsa-input>
                    </div>
                    <div class="col">
                        <app-lfsa-input formControlName="extractoraHumedad" [label]="'Humedad Extractora'" [id]="'extractoraHumedad'"
                        [control]="formulario.get('compras.extractoraHumedad')" class="form-control-sm" [type]="'number'" class="form-control-sm" maxlength="7">
                        </app-lfsa-input>
                    </div>
                    <div class="col">
                        <app-lfsa-input formControlName="extractoraImpureza" [label]="'Impureza Extractora'" [id]="'extractoraImpureza'"
                        [control]="formulario.get('compras.extractoraImpureza')" class="form-control-sm" [type]="'number'" class="form-control-sm" maxlength="7">
                        </app-lfsa-input>
                    </div>
                </div>

                <div class="row">
                    <div class="col">
                        <app-lfsa-input formControlName="placa" [label]="'* Placa'" [id]="'placa'" [control]="formulario.get('placa')"
                        (change)="getPlaca();" [type]="'text'" class="form-control-sm" >
                        </app-lfsa-input>
                    </div>
                    <div class="col">
                        <app-lfsa-combo-box [label]="'* Tipo de Recurso'" formControlName="tipoRecurso" [control]="formulario.get('tipoRecurso')"
                                            [comboBox]="listTipoTransporte" [opcion]="'clave'" [idOpcion]="'valor'" class="form-control-sm" (change)="getFurgonesFilter()">
                        </app-lfsa-combo-box>
                    </div>
                    <div class="col">
                        <label class="claseLabel" for="furgon">* Seleccione Furgon</label>
                        <ng-select [items]="listFurgones"
                                   [labelForId]="'furgon'"
                                   formControlName="furgon"
                                   placeholder="Seleccione un Furgon"
                                   [clearable]="false"
                                   bindLabel="marca"
                                   bindValue="placa"
                                   [addTag]="permiteDigitarFurgon ? addTagFurgon : false"
                                   [ngClass]="{'is-invalid': formulario.get('furgon').invalid && formulario.get('furgon').dirty, 'is-valid': formulario.get('furgon').valid && formulario.get('furgon').dirty}">
                        </ng-select>
                    </div>
                </div>
                <div class="row">
                    <div class="col-md-6">
                        <app-lfsa-input formControlName="proveedorId" [label]="'* Código proveedor Transporte'" [id]="'proveedorId'" [control]="formulario.get('proveedorId')"
                        [placeholder]="'Código proveedor'" (change)="getProveedor(); getPlacas(formulario.get('proveedorId').value); this.getTiposRecursos();  this.getFurgones();" class="form-control-sm" [type]="'text'" class="form-control-sm" >
                        </app-lfsa-input>
                    </div>
                    <div class="col-md-6">
                        <app-lfsa-input formControlName="proveedorNombre" [label]="'* Detalle proveedor'" [id]="'proveedorNombre'" [control]="formulario.get('proveedorNombre')"
                        [placeholder]="'Nombre proveedor'" [type]="'text'" class="form-control-sm" [isReadOnly]="true">
                        </app-lfsa-input>
                    </div>
                </div>
                <div class="row">
                    <div class="col">
                        <!--<app-lfsa-input formControlName="choferCedula" [label]="'* Cédula chofer'" [id]="'choferCedula'" [control]="formulario.get('choferCedula')"
                        [placeholder]="'Ingrese cédula del chofer (sin - u otros simbolos)'" (change)="getChofer();" [type]="'text'" class="form-control-sm" >
                        </app-lfsa-input>
                        -->
                        <app-lfsa-input formControlName="choferNombre" [label]="'* Filtrar por nombre chofer'" [id]="'choferNombre'" [control]="formulario.get('choferNombre')"
                        [placeholder]="'Nombre chofer'" [type]="'text'" class="form-control-sm" (change)="getChofer();">
                        </app-lfsa-input>

                    </div>
                    <div class="col">
                        <app-lfsa-combo-box [label]="'* Lista de Choferes'" formControlName="choferCedula" [control]="formulario.get('choferCedula')"
                                            [comboBox]="listChoferes" [opcion]="'nombres'" [idOpcion]="'cedula'" class="form-control-sm" >
                        </app-lfsa-combo-box>
                    </div>

                    <div class="col">
                        <app-lfsa-input formControlName="choferTelefono" [label]="'* Télefono chofer'" [id]="'choferTelefono'" [control]="formulario.get('choferTelefono')"
                        [placeholder]="'Télefono chofer'" [type]="'text'" class="form-control-sm" >
                        </app-lfsa-input>
                    </div>
                </div>

                <strong>Origen y Destino</strong>
                <div class="row py-2 border border-success rounded">
                    <!--  T.42031 RF: 1.6 1.7 -->
                    <div class="col-sm form-group" *ngIf="this.tipoSelected?.tipoEscenario != 'VENTA'">
                        <app-lfsa-combo-box [label]="'* Seleccione Centro Destino'" formControlName="centroDestino" [control]="formulario.get('centroDestino')"
                                            [comboBox]="LISTA_CENTO_DESTINO" [opcion]="'descripcion'" [idOpcion]="'id'" (change)="getAlmacen(false);" class="form-control-sm">
                        </app-lfsa-combo-box>
                    </div>
                    <!-- AMPLIACION DE CAMPOS 5 -->
                     <!--  T.42031 RF: 1.6 1.7 -->
                    <div class="col-sm form-group" *ngIf="this.tipoSelected?.tipoEscenario != 'VENTA'">
                        <app-lfsa-combo-box [label]="'Bodega/Recepción Destino'" formControlName="almacenDestino" [control]="formulario.get('almacenDestino')"
                                            [comboBox]="listAgenciasDestino" [opcion]="'dscaAlmacen'" [idOpcion]="'idAlmacen'" class="form-control-sm"
                                            [isReadOnly]="true">
                        </app-lfsa-combo-box>
                    </div>
                    <div class="col-sm form-group">
                        <app-lfsa-combo-box [label]="'* Seleccione Centro Carga Origen'" formControlName="centroOrigen" [control]="formulario.get('centroOrigen')"
                                            [comboBox]="listCentros" [opcion]="'nombreCentro'" [idOpcion]="'idCentro'" (change)="getAlmacenByCentroUser($event);" class="form-control-sm">
                        </app-lfsa-combo-box>
                    </div>
                    <div class="col-sm form-group">
                        <app-lfsa-combo-box [label]="'* Seleccione Bodega/Carga Origen'" formControlName="bodegaCarga" [control]="formulario.get('bodegaCarga')"
                                            [comboBox]="listAgencias" [opcion]="'dscaAlmacen'" [idOpcion]="'idAlmacen'" class="form-control-sm" >
                        </app-lfsa-combo-box>
                    </div>
                </div>
                <hr>

                <div class="row py-2">
                <!-- AMPLIAR PLANIFICACION 6 -->
                <!-- *ngIf="!this.isFocus" -->
                <div class="col" *ngIf="tipoSelected?.requiereArea">
                    <app-lfsa-combo-box [label]="'* Áreas por Centro destino'" formControlName="areaId" [control]="formulario.get('areaId')"
                                        [comboBox]="listAreas" [opcion]="'descArea'" [idOpcion]="'idArea'" class="form-control-sm">
                    </app-lfsa-combo-box>
                </div>
                <!-- *ngIf="!this.isFocus" -->
                <div class="col">
                    <app-lfsa-input formControlName="materialId" [label]="'Código material'" [id]="'materialId'" [control]="formulario.get('materialId')"
                    [placeholder]="'Código material'" class="form-control-sm" [type]="'text'" class="form-control-sm" >
                    </app-lfsa-input>
                </div>
                <!-- *ngIf="!this.isFocus" -->
                <div class="col">
                    <app-lfsa-input formControlName="materialRef" [label]="'Referencia material'" [id]="'materialRef'" [control]="formulario.get('materialRef')"
                    [placeholder]="'referencia'" class="form-control-sm" [type]="'text'" class="form-control-sm" >
                    </app-lfsa-input>
                </div>

                <div class="col">
                    <label for="fechaLlegada" style="font-size: .875rem;">Fecha y hora planificada de llegada</label>
                    <input autocomplete="off" class="form-control" formControlName="fechaLlegada" (change)="onFechaLlegadaChange()"
                    id="fechaLlegada" name="fechaLlegada" type="datetime-local" min="2025-01-01T00:00" max="2030-12-31T00:00" />
                    <small *ngIf="this.formulario.get('fechaLlegada')?.hasError('required') && this.formulario.get('fechaLlegada').touched"
                    class="text-danger">*Campo obligatorio</small>
                  <small *ngIf="this.formulario.get('fechaLlegada')?.hasError('pastDate') && this.formulario.get('fechaLlegada').touched"
                         class="text-danger">*La fecha no puede ser menor a la actual</small>
                </div>

                <div class="col">
                    <app-lfsa-combo-box [label]="'* Estado '" formControlName="estado" [control]="formulario.get('estado')"
                                        [comboBox]="cmbxEstados" [opcion]="'valor'" [idOpcion]="'clave'" [habilitar]="true" class="form-control-sm">
                    </app-lfsa-combo-box>
                </div>
            </div>

            <app-lfsa-botones-formulario
                (devolverAccion) ="acciones($event)"
                [formularioValido] ="formulario.invalid"
                [mostrarBotonVerde] = "permiteEditar"
                [loading]="loading" [textBoton]="'Guardar'" class="row p-3">
            </app-lfsa-botones-formulario>
        </form>
        </div>
    </ng-template>
    <!-- END MODAL -->

    <!-- MODAL DATOS BALANZA-->
    <app-lfsa-modal [innTemplate]="abrirModallBalanza" [classModal]="'modal-dialog modal-lg'" [idButton]="'fillOne'"  [idOpen]="'Modal2'"
                    [idClose]="'cerrarModalBalanza'" [titulo]="'Datos de Balanza'" ></app-lfsa-modal>
    <ng-template #abrirModallBalanza>
        <div class="container-fluid">

            <div class="card border-warning mb-3" >
                <div class="card-body" *ngIf="rowData">
                <h5 class="card-title" style="font-size: medium; ">Viaje #  {{ selected?.idViaje }}</h5>
                    <div class="row">
                    <div class="col" style="font-size: smaller;">Proveedor: {{ selected?.proveedorNombre }} </div>
                    <div class="col" style="font-size: smaller;">Placa: {{ selected?.placa }}  </div>
                    </div>
                </div>
            </div>
            <div class="col-md-2"><span class="badge text-bg-success">{{selected?.estado}}</span></div>
            <h5>Verifique valores de balanza</h5>
            <br>
            <h6> Hora Inicio Proceso: {{fechaHoraInicio}} </h6><hr>

            <!-- FORMULARIO DE BALANZA -->
            <form [formGroup]="formBalanza" novalidate class="form-group">
                <div class="row">
                    <div class="col">
                        <app-lfsa-input formControlName="garitaTicket" [label]="'* Garita Ticket'" [id]="'garitaTicket'" [control]="formBalanza.get('garitaTicket')"
                            [type]="'number'" class="form-control-sm" [isReadOnly]="true">
                        </app-lfsa-input>
                    </div>
                    <div class="col">
                        <app-lfsa-input formControlName="balanzaTicket" [label]="'* Orden de balanza'" [id]="'balanzaTicket'" [control]="formBalanza.get('balanzaTicket')"
                        [placeholder]="'Ingrese número de orden'" [type]="'number'" class="form-control-sm" [isReadOnly]="true">
                        </app-lfsa-input>
                    </div>
                    <div class="col">
                        <app-lfsa-input formControlName="pesoIn" [label]="'* Peso Entrada'" [id]="'pesoIn'" [control]="formBalanza.get('pesoIn')"
                            [type]="'number'" class="form-control-sm" [isReadOnly]="true">
                        </app-lfsa-input>
                    </div>
                    <div class="col">
                        <app-lfsa-input formControlName="pesoOut" [label]="'* Peso Salida'" [id]="'pesoOut'" [control]="formBalanza.get('pesoOut')"
                            [type]="'number'" class="form-control-sm" >
                        </app-lfsa-input>
                    </div>
                    <div class="col" *ngIf="tipoSelected?.generaTicketBalanza && permiteCapturaPeso">
                        <label>Capturar</label>
                        <button (click)="getCapturarPeso()" class="btn btn-block btn-info text-white"><i aria-hidden="true" class="fas fa-sync-alt"></i></button>
                    </div>
                </div>

                <div class="row">
                    <div class="col" *ngIf="tipoSelected?.generaTicketBalanza && permiteCapturaPeso">
                      <label> TIPO ID => {{selected?.tipoOrdenBalanza}} </label>
                      <button (click)="crearOB()" class="btn btn-block btn-primary"> <i aria-hidden="true" class="fa fa-plus"></i>  GENERAR ORDEN BALANZA </button>
                    </div>

                    <div class="col">
                        <app-lfsa-input formControlName="fSalidaGarita" [label]="'Fecha Salida Garita'" [id]="'fSalidaGarita'" [control]="formBalanza.get('fSalidaGarita')"
                        [type]="'text'" class="form-control-sm" [isReadOnly]="true">
                        </app-lfsa-input>
                    </div>

                    <div class="col">
                        <app-lfsa-input formControlName="estadoOB" [label]="'Estado Actual OB'" [id]="'estadoOB'" [control]="formBalanza.get('estadoOB')"
                        [type]="'text'" class="form-control-sm" [isReadOnly]="true">
                        </app-lfsa-input>
                    </div>

                    <div class="col">
                        <app-lfsa-input formControlName="estado" [label]="'Estado Proceso de Balanza'" [id]="'estado'" [control]="formBalanza.get('estado')"
                        [type]="'text'" class="form-control-sm" [isReadOnly]="true">
                        </app-lfsa-input>
                    </div>

                    <!--
                    <div class="col">
                        <p><b>Fecha y Hora Balanza Out</b></p>{{selected?.balanzaFechaFin}}
                    </div>

                    <div class="col form-group">
                        <label for="estado">Proceso de Balanza</label>
                        <select class="form-control" formControlName="estado">
                        <option value="">-- Seleccione --</option>
                        <option value="BALANZA_IN">Iniciar Balanza</option>
                        <option value="BALANZA_OUT">Finalizar Balanza</option>
                        </select>
                        <small *ngIf="formBalanza.controls['estado'].errors && formBalanza.controls['estado'].touched" class="text-danger">*Este campo es inválido</small>
                    </div>
                    [mostrarBotonVerde] = "true"
                    -->
                </div>

                <app-lfsa-botones-formulario
                    (devolverAccion) ="acciones($event)"
                    [formularioValido] ="formBalanza.invalid"
                    [mostrarBotonVerde] = "validadoPesos"
                    [loading]="loading" [textBoton]="'Guardar'" class="row p-3">
                </app-lfsa-botones-formulario>
            </form>
        </div>
    </ng-template>
    <!-- END MODAL -->
